<mat-toolbar class="p8-bdc_breadcrumb__container mat-elevation-z1" color="primary" style="height: 100px">
<!--  fxFlex.xs="calc(40% - 5px)"-->
  <div fxLayoutAlign="start"
       fxFlex="calc(70% - 5px)"
       [ngClass]="'p8-bdc_breadcrumb__truncate'">
    <button mat-icon-button (click)="toggleSidenav()">
      <mat-icon aria-label="Toggle menu">menu</mat-icon>
    </button>
    <span class="p8-bdc_breadcrumb__title">
      <span class="p8-bdc_breadcrumb__link" [routerLink]="['/']">Accueil </span> /
      <span class="p8-bdc_breadcrumb__link" [routerLink]="['/page/', page?.id]">{{ page?.data.title }}</span>
    </span>
  </div>
  <!--<span fxFlex  style="border: green solid 1px"></span>-->
<!--  fxFlex.xs="calc(60% - 5px)"-->
  <p8-bdc-search-pages fxHide.xs
    fxFlex="calc(30% - 5px)" fxLayoutAlign="end" appearance="outline" floatLabel="never"></p8-bdc-search-pages>

</mat-toolbar>
